import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

const TitleUpdater = ({ title, description ,children }) => {
  const location = useLocation(); // get current path
  useEffect(() => {
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    document.title = title;

    // Update canonical link
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${window.location.origin}${location.pathname}`);

  }, [title , description , location.pathname]);

  return <>{children}</>;
};

export default TitleUpdater;